export default function () {
  let portfolioData, portfolioTransactionsData,
    portfolioStocksTableData,
    portfolioDematTableData,
    portfolioFixedBankTableData,
    portfolioSavingBankTableData,
    portfolioLoanTableData,
    realEstateTableData,
    commodityTableData,
    bankList;
  return {
    portfolioData,
    portfolioTransactionsData,
    portfolioStocksTableData,
    portfolioDematTableData,
    portfolioFixedBankTableData,
    portfolioSavingBankTableData,
    portfolioLoanTableData,
    realEstateTableData,
    commodityTableData,

    bankList,
  };
}
